<template>
  <div class="customer">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <!-- <van-icon name="arrow-left" color="#fff" @click="returnIndex" /> -->
          <van-search v-model="value" placeholder="查找" @input="searchInput" style="margin:0 10px;" />
          <img class="imgHeader" src="../../assets/icon/addNurse.png" alt="" @click="add">
        </div>
      </div>
      <van-tabs v-model="active" class="tabAll" @click="activeChange">
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="患者" name="1"></van-tab>
        <van-tab title="陪同" name="2"></van-tab>
      </van-tabs>
    </van-sticky>

    <div style="margin-bottom:70px;" v-if="tableData">
      <!-- 护士账号页面 -->
      <customNurse></customNurse>
      <!-- 预检台账号页面 -->
      <customFlat></customFlat>
      <!-- 客服账号页面 -->
      <customServise></customServise>
    </div>
    <div v-if="tableData.length==0">
      <div class="indexWhite">
        <img src="../../assets/img/my-white.png" alt="">
      </div>
      <div class="whitePart">暂无患者</div>
    </div>
  </div>
</template>
<script>
import CustomFlat from './customFlat.vue'
import customNurse from './customNurse.vue'
import CustomServise from './customServise.vue'
export default {
  components: {
    customNurse,
    CustomFlat,
    CustomServise
  },
  data() {
    return {
      active: '0',
      value: '',
      tableData: [
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },

      ],
      status: '',
    }
  },
  created() { },
  methods: {
    returnIndex() {
      this.$router.push("/aboutUs")
    },
    activeChange(val, title) { },
    // 关键字查询
    searchInput(val) { },
    add() {
      this.$router.push("/addCustomer")
    }
  },
}

</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>



// WEBPACK FOOTER //
// src/components/customerReception/customer.vue